<template>
    <div :class="['justify-content-center-mode', 'calculator']">
        <div class="col-md-5">
            <div class="block-section sul-box-raised-1 with-hover" style="padding: 16px; padding-top: 8px; padding-bottom: 32px; margin-bottom: 56px;position: relative;overflow: hidden;">
                <div class="block-section">
                    <h2 class="title-section">THE <span class="block-text">MASTERNODE</span> CALCULATOR</h2>
                    <p style="line-height: 1.5rem;">
                        <br/>
                        This is a community made project to project the future value of your masternodes.
                        <br/>
                        <br/>
                        The Stakenet team has released their Hydra network Masternode fee breakdown, in this <a href="https://medium.com/stakenet/hydra-dex-network-upgrade-proposal-4b00a3a3fb8" class="sul-link" target="_blank"><strong>Medium Article</strong></a>.
                        <br/>
                        Read the article to understand the Stakenet Masternode and its role in the Stakenet DEX and Ecosystem.
                        <br/>
                        <br/>
                        Adjust the sliders below to calculate the value of your Masternodes, as well as the yearly return from them.
                    </p>
                </div>
                <img v-if="stonky" class="md-wojak" src="../assets/md-wojak.jpeg" alt="wojak" />
            </div>

            <div class="mega-row">
                <div class="calc-block">
                    <div class="block-section sul-box-raised-1 with-hover" style="padding: 16px;">
                        <div class="slider-row" style="margin-top: 32px">
                            <h2 class="title-section" style="margin-top:0px;">
                                CURRENT XSN PRICE
                                <br/>
                                <span class="value-small-font sub-title-text">(bitfinex):</span>
                            </h2>
                            <p class="slider-row-value block med-value">
                                ${{currentXsnPriceString}}
                                <br/>
                                <span class="sub-title-text">(${{currentMNPriceString}}/MN)</span>
                            </p>
                        </div>
                    </div>                    
                    <div class="sul-box-raised-1 with-hover" style="padding: 16px; margin-top: 24px">
                        <div class="block-section">
                            <h2 class="title-section" style="margin-top: 12px;"><span class="block-text">BLOCK</span> REWARDS</h2>
                            <p style="line-height: 1.5rem;">
                                Masternodes continually earn block rewards, the value of those rewards is based upon the price of XSN, and how many masternodes it is split between:
                                <br/>
                                <br/>
                            </p>
                        </div>
                        <div class="block-section">
                            <div class="slider-row">
                                <p class="slider-row-text">XSN price:</p>
                                <input type="range" class="sul-range slider-row-slider block" min="0" max="100" v-model="xsnPriceLog">
                                <p class="slider-row-value block" v-text="`$${xsnPriceString}`"/>
                            </div>
                        </div>
                        <div class="block-section">
                            <div class="slider-row">
                                <p class="slider-row-text">Total<br/>Masternodes:</p>
                                <input type="range" class="sul-range slider-row-slider block" min="2300" max="4000" step="100" v-model="masternodeCount">
                                <p class="slider-row-value block" v-text="`${masternodeCount}`"/>
                            </div>
                        </div>
                        <div class="block-section">
                            <div class="slider-row">
                                <p class="slider-row-text">Your<br/>Masternodes:</p>
                                <input type="range" class="sul-range slider-row-slider block" min="2" max="100" v-model="ownedNodesLog">
                                <p class="slider-row-value block" v-text="`${ownedNodes}`"/>
                            </div>
                        </div>


                        <div class="block-section">
                            <h2 class="title-section"><span class="orderbook-text">ORDERBOOK</span> REWARDS</h2>
                            <p style="line-height: 1.5rem;">
                                MNs can earn extra rewards by hosting the orderbook when Hydra is released:
                                <br/>
                                <br/>
                            </p>
                        </div>
                        <div class="block-section">
                            <div class="slider-row">
                                <p class="slider-row-text wide">Enable orderbook hosting on your MNs<br/>(extra cost):</p>
                                <input type="checkbox" class="sul-checkbox-type-2 checkbox-color" v-model="orderbookHostingEnabled">
                            </div>
                        </div>
                        <div :class="['block-section', 'transition-opacity', !orderbookHostingEnabled && 'low-opacity']">
                            <div class="slider-row">
                                <p class="slider-row-text">Daily Trading<br>Volume:</p>
                                <input type="range" class="sul-range slider-row-slider trading" min="1" max="100" v-model="tradingVolumeLog">
                                <p class="slider-row-value trading" v-text="`$${tradingVolumeString}`"/>
                            </div>
                        </div>
                        <div :class="['block-section', 'transition-opacity', !orderbookHostingEnabled && 'low-opacity']">
                            <div class="slider-row">
                                <p class="slider-row-text">MNs Hosting<br>Orderbook:</p>
                                <input type="range" class="sul-range slider-row-slider trading" min="1000" max="3000" step="100" v-model="orderbookMNs">
                                <p class="slider-row-value trading" v-text="orderbookMNs"/>
                            </div>
                        </div>
                        
                        <div class="block-section">
                            <h2 class="title-section"><span class="lightning-routing-text">LIGHTNING ROUTING</span> REWARDS <span class="lightning-routing-text tba-text">TBA</span></h2>
                        </div>
                        <div class="block-section">
                            <h2 class="title-section"><span class="channel-liquidity-text">CHANNEL LIQUIDITY</span> REWARDS <span class="channel-liquidity-text tba-text">TBA</span></h2>
                        </div>
                    </div>
                </div>

                <div class="calc-block">
                    <div class="block-section sul-box-raised-1 with-hover" style="padding: 16px;">
                        <div class="slider-row" style="margin-top: 24px">
                            <h2 class="title-section" style="margin-top:0px;">
                                MN COLLATERAL VALUE
                                <br/>
                                <span class="value-small-font sub-title-text">({{ownedNodes}}MN @ ${{xsnPriceString}}XSN):</span>
                            </h2>
                            <p class="slider-row-value block med-value">
                                ${{mnCollateralValueString}}
                            </p>
                        </div>
                    </div>
                    <div class="sul-box-raised-1 with-hover" style="padding: 16px; margin-top: 24px">
                        <div class="block-section">
                            <div class="slider-row">
                                <p class="title-section calculated-text">TIMESCALE:</p>
                                <div class="radio-row">
                                <input
                                    type="radio"
                                    class="sul-radio radio-button"
                                    name="radio"
                                    :value="'day'"
                                    v-model="dayMonthYear"> <span class="radio-text">Day</span>
                                <input
                                    type="radio"
                                    class="sul-radio radio-button"
                                    name="radio"
                                    :value="'month'"
                                    v-model="dayMonthYear"> <span class="radio-text">Month</span>
                                <input
                                    type="radio"
                                    class="sul-radio radio-button"
                                    name="radio"
                                    :value="'year'"
                                    v-model="dayMonthYear"> <span class="radio-text">Year</span>
                                </div>
                            </div>
                        </div>

                        <div class="block-section">
                            <div class="slider-row">
                                <h2 class="title-section calculated-text">CALCULATED<br/>BLOCK REWARDS:</h2>
                                <p class="slider-row-value block big-value">
                                    ${{blockRewardsString}}
                                    <br/>
                                    <span class="value-small-font">/{{dayMonthYear}}</span>
                                </p>
                            </div>
                        </div>
                        <div :class="['block-section', 'transition-opacity', !orderbookHostingEnabled && 'low-opacity']">
                            <div class="slider-row">
                                <h2 class="title-section calculated-text">CALCULATED ORDERBOOK<br/>HOSTING REWARDS:</h2>
                                <p class="slider-row-value trading big-value">
                                    + ${{orderbookRewardsString}}
                                    <br/>
                                    <span class="value-small-font">/{{dayMonthYear}}</span>
                                </p>
                            </div>
                        </div>
                        <div class="block-section">
                            <div class="slider-row">
                                <h2 class="title-section calculated-text">MASTERNODE <br/>HOSTING COST:</h2>
                                <p class="slider-row-value gray big-value">
                                    - ${{mnHostingCostString}}
                                    <br/>
                                    <span class="value-small-font">/{{dayMonthYear}}</span>
                                </p>
                            </div>
                        </div>
                        <div class="addition-divider"/>
                        <div class="block-section">
                            <div class="slider-row">
                                <h2 class="title-section calculated-text">TOTAL REWARDS: <br/><span class="sub-title-text">(est)</span></h2>
                                <p class="slider-row-value block big-value">
                                    ${{totalRewardsString}}
                                    <br/>
                                    <span class="value-small-font">/{{dayMonthYear}}</span>
                                </p>
                            </div>
                        </div>
                        <div class="h-divider"/>
                        <div class="block-section">
                            <div class="slider-row">
                                <h2 class="title-section calculated-text">ROI:<br><span style="font-size: 12px">(collateral + rewards) / collateral</span></h2>
                                <p class="slider-row-value block med-value">
                                    {{roi}}%
                                    <br/>
                                    <span class="value-small-font">/{{dayMonthYear}}</span>
                                </p>
                            </div>
                        </div>
                        <div v-if="stonky" class="h-divider"/>
                        <div v-if="stonky" class="block-section">
                            <div class="slider-row">
                                <h2 class="title-section calculated-text">McD WAGIE EQUIVALENCE:<br><span style="font-size: 12px">(23.7k / year)</span></h2>
                                <p class="slider-row-value block med-value">
                                    {{wagieEquivalence}}
                                    <br/>
                                    <span class="value-small-font">McDonalds Salaries</span>
                                </p>
                            </div>
                            <div class="mcd-worker-row">
                                <img
                                    v-for="index in wagieEquivalenceCeil"
                                    :key="index"
                                    :class="['mcd-worker', wagieEquivalenceCeil > 12 && 'mcd-worker-small']"
                                    :style="index > wagieEquivalence ? {width: ((1 - (index - wagieEquivalence)) * (wagieEquivalenceCeil > 12 ? 30 : 100) * (166/202) + 'px')} : undefined"
                                    src="../assets/md-worker.jpeg"
                                    alt="mcWorker"/>
                            </div>
                        </div>
                        <div class="h-divider"/>
                        <div class="block-section">
                            <div class="slider-row">
                                <h2 class="title-section calculated-text">DAYS UNTIL FREE:<br>MASTERNODE EARNED</h2>
                                <p class="slider-row-value block med-value">
                                    {{daysUntilFreeMasternode}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="block-section sul-box-raised-1 with-hover" style="padding: 16px; margin-top: 24px">
                        <div class="slider-row" style="margin-top: 0px; margin-bottom: 0px;">
                            <p class="tip-text channel-liquidity-text" style="line-height:30px;">
                                <span style="letter-spacing: 6px;">Architect:</span>
                                <br/>
                                XSN: 7Yo9HAHdAg9SD585NgwAdQXZgqbqdw3MS5
                                <br/>
                                ETH: 0xBaA965d0C416b9edCBe1628E8dDB993bF576b68A
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    
    
    export default {
        data() {
            return {
                currentXsnPrice: 1,
                xsnPriceLog: 23,
                tradingVolumeLog: 30,
                ownedNodesLog: 2,
                masternodeCount: 2700,
                dayMonthYear: "month",
                orderbookHostingEnabled: true,
                orderbookMNs: 1500,
            }
        },
        mounted() {
            // this.axios
            //     .get('https://whitebit.com/api/v4/public/trades/XSN_USDT')
            //     .then(response => console.log(response))
            const ws = new WebSocket('wss://api-pub.bitfinex.com/ws/2');

            let self = this

            ws.onmessage = function(msg){
                const parsed = JSON.parse(msg.data)
                if (parsed[1] !== undefined && parsed[1][0] !== undefined) {
                    if (!isNaN(parseFloat(parsed[1][0]))) {
                        self.currentXsnPrice = parsed[1][0]
                    }
                }
            }
            
            let msg = JSON.stringify({ 
                event: 'subscribe', 
                channel: 'ticker', 
                symbol: 'tXSNUSD' 
            })

            ws.onopen = function(){
                ws.send(msg)
            }
        },
        methods: {
            toFinString: function (x, fixed = 2) {
                if (x < 1000000) {
                    return x.toFixed(fixed).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else if (x < 1000000000) {
                    return (x / 1000000).toFixed(fixed).toString() + 'M'
                } else {
                    return (x / 1000000000).toFixed(fixed).toString() + 'B'
                }
            },
            clicked: function (val) {
                this.dayMonthYear = val
            },
            onEdit(evt, editedVar){
                var src = evt.target.innerText
                editedVar = src
                console.log(editedVar)
            },
            endEdit(){
                this.$el.querySelector('.editme').blur()
            },
        },
        computed: {
            stonky: function () {
                return this.$store.state.stonky
            },
            xsnPrice: function() {
                if (this.xsnPriceLog == 100) return 1000
                if (this.xsnPriceLog > 98) return 500
                return Math.round(Math.exp(Math.log(1) + ((Math.log(500) - Math.log(1)) / 100) * this.xsnPriceLog))
            },
            xsnPriceString: function() {
                return this.toFinString(this.xsnPrice)
            },
            currentXsnPriceString: function() {
                return this.toFinString(this.currentXsnPrice, 3)
            },
            currentMNPriceString: function() {
                return this.toFinString(this.currentXsnPrice * 15000, 2)
            },
            ownedNodes: function() {
                return Math.round(this.ownedNodesLog < 50 ? this.ownedNodesLog / 2 : (((this.ownedNodesLog - 50) * 1.5) + 25))
            },
            tradingVolume: function() {
                const val = Math.round(this.tradingVolumeLog < 50 ? (this.tradingVolumeLog * 20) / 2 : (((this.tradingVolumeLog - 50) * 100 * 3.9) + 500))
                return val > 1000 ? Math.round(val / 500) * 500 : val
            },
            tradingVolumeString: function() {
                return this.tradingVolume < 1000 ? (this.tradingVolume + 'M') : ((this.tradingVolume / 1000).toFixed(2) + "B")
            },
            dayMonthYearMultiplier: function() {
                return (this.dayMonthYear === 'day' ? 1 : this.dayMonthYear === 'month' ? 30 : 365)
            },
            blockRewards: function () {
                return (this.ownedNodes / this.masternodeCount) * (1440 * 9) * this.xsnPrice * this.dayMonthYearMultiplier
            },
            blockRewardsString: function () {
                return this.toFinString(this.blockRewards)
            },
            orderbookRewards: function() {
                return Math.max(0.225, (0.45 - (0.000225 * this.tradingVolume))) * (this.tradingVolume * 0.0025 * 1000000) * (this.ownedNodes / this.orderbookMNs) * this.dayMonthYearMultiplier
            },
            orderbookRewardsString: function() {
                return this.toFinString(this.orderbookRewards);
            },
            mnHostingCost: function() {
                return this.ownedNodes * (this.orderbookHostingEnabled ? 2.5 : 0.15) * this.dayMonthYearMultiplier
            },
            mnHostingCostString: function() {
                return this.toFinString(this.mnHostingCost);
            },
            mnCollateralValue: function () {
                return this.xsnPrice * this.ownedNodes * 15000
            },
            mnCollateralValueString: function () {
                return this.toFinString(this.mnCollateralValue)
            },
            totalRewards: function() {
                return this.blockRewards + (this.orderbookHostingEnabled ? this.orderbookRewards : 0) - this.mnHostingCost
            },
            totalRewardsString: function() {
                return this.toFinString(this.totalRewards)
            },
            roi: function() {
                return ((((this.mnCollateralValue + this.totalRewards) / this.mnCollateralValue) - 1) * 100).toFixed(2)
            },
            daysUntilFreeMasternode: function() {
                return ((15000 * this.xsnPrice) / (this.totalRewards / this.dayMonthYearMultiplier)).toFixed(1) + ' days'
            },
            wagieEquivalence: function() {
                return ((this.totalRewards / this.dayMonthYearMultiplier) * 365 / 23700).toFixed(1);
            },
            wagieEquivalenceCeil: function() {
                return Math.ceil((this.totalRewards / this.dayMonthYearMultiplier) * 365 / 23700)
            }
        }
    }
</script>